import { Tags, LoadBlock } from '@bwoty-web/styleguide';
import PropTypes from 'prop-types';
import styles from './FlightHitHeader.scss';

export function FlightHitHeader(props) {
  const {
    date,
    month,
    weekday,
    destinationAirport,
    country,
    departure,
    duration,
    numFreeSeats,
    dayLabel,
    daysLabel,
    fewSeatLabel,
    fewSeatsLabel,
    perPersonLabel,
    isLoading,
  } = props;

  const hasCountry = country && country.url && country.name;

  const destinationCountry = hasCountry ? (
    <a href={country.url} className={styles.resortCountry}>
      {country.name}
    </a>
  ) : null;

  const seatTag =
    !isLoading && numFreeSeats <= 8 ? (
      <Tags
        className={styles.tags}
        tags={[
          {
            text: `${numFreeSeats} ${numFreeSeats === 1 ? fewSeatLabel : fewSeatsLabel}`,
            theme: 'few-seats',
          },
        ]}
        small
      />
    ) : null;

  const dateHeader = isLoading ? (
    <LoadBlock style={{ width: 55, height: 30 }} />
  ) : (
    <div className={styles.dateHeader}>
      <span className={styles.date}>{date}</span>
      <div className={styles.dateText}>
        <span className={styles.dateMonth}>{month}</span>
        <span className={styles.dateWeekday}>{weekday}</span>
      </div>
    </div>
  );

  return (
    <div className={styles.root}>
      {seatTag}
      <div className={styles.container}>
        <div className={styles.dateContainer}>{dateHeader}</div>

        <div className={styles.resortContainer}>
          {isLoading ? (
            <div className={styles.resortName}>
              <LoadBlock style={{ width: 100, height: 21, marginBottom: 2 }} />
            </div>
          ) : (
            <p className={styles.resortName}>
              <strong className={styles.resortAirport}>
                {destinationAirport}
                {hasCountry ? <span>, </span> : null}
              </strong>
              {destinationCountry}
            </p>
          )}
          {isLoading ? (
            <span className={styles.departure}>
              <LoadBlock style={{ width: 200, height: 16 }} />
            </span>
          ) : (
            <span className={styles.departure} data-test="lms-hit-departure">
              {`${departure.name}, ${duration} ${duration > 1 ? daysLabel : dayLabel}`}
            </span>
          )}
        </div>

        <span className={styles.perPersonLabel}>{isLoading ? '' : perPersonLabel}</span>
      </div>
    </div>
  );
}

FlightHitHeader.propTypes = {
  isLoading: PropTypes.bool,
  date: PropTypes.node,
  month: PropTypes.node,
  weekday: PropTypes.node,
  destinationAirport: PropTypes.node,
  numFreeSeats: PropTypes.number,
  duration: PropTypes.number,
  departure: PropTypes.shape({ name: PropTypes.string }),
  country: PropTypes.shape({ name: PropTypes.string, url: PropTypes.string }),
  dayLabel: PropTypes.node,
  daysLabel: PropTypes.node,
  fewSeatLabel: PropTypes.node,
  fewSeatsLabel: PropTypes.node,
  perPersonLabel: PropTypes.node,
};
